import React from 'react';
import { classes } from '../../Tabs.st.css';
import { SideContentProps } from './SideContent.types';

const SideContent = ({ content }: SideContentProps) =>
  content ? (
    <div data-content="true" className={classes.sideContent}>
      {content}
    </div>
  ) : null;

export default SideContent;
